"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var geostyler_sld_parser_1 = __importDefault(require("geostyler-sld-parser"));
var _isEqual = require('lodash/isEqual');
require("./SLDRenderer.css");
var HTTPUtil_1 = __importDefault(require("../../../Util/HTTPUtil"));
var LoadingIcon_1 = __importDefault(require("./LoadingIcon"));
/**
 * Symbolizer Renderer UI.
 */
var SLDRenderer = /** @class */ (function (_super) {
    __extends(SLDRenderer, _super);
    function SLDRenderer(props) {
        var _this = _super.call(this, props) || this;
        /**
         * The function that sets the legends graphic for the symbolizers
         *
         * @param {Symbolizer[]} symbolizers The passed symbolizer
         */
        _this.setLegendGraphicUrlForRule = function (symbolizers) {
            var _a = _this.props, requestDelay = _a.requestDelay, additionalHeaders = _a.additionalHeaders;
            _this.setState({
                legendDataUrl: LoadingIcon_1.default
            });
            if (_this._requestTimeout) {
                clearTimeout(_this._requestTimeout);
            }
            _this._requestTimeout = setTimeout(function () {
                var _a = _this.props, wmsBaseUrl = _a.wmsBaseUrl, layer = _a.layer, rasterLayer = _a.rasterLayer, width = _a.width, height = _a.height, wmsParams = _a.wmsParams;
                var style = {
                    name: 'sld-renderer-style',
                    rules: [{
                            name: '',
                            symbolizers: symbolizers
                        }]
                };
                var lyr;
                // As soon as a symbolizer is of type raster symbolizer,
                // we will only create a legendGraphic for raster layers
                // as wms cannot return a mixed legendGraphic
                // TODO
                if (symbolizers.some(function (symbolizer) { return symbolizer.kind === 'Raster'; })) {
                    lyr = rasterLayer || layer;
                }
                else {
                    lyr = layer;
                }
                _this._styleParser.writeStyle(style)
                    .then(function (sld) {
                    var params = __assign({ 'SERVICE': 'WMS', 'VERSION': '1.3.0', 'REQUEST': 'GetLegendGraphic', 'FORMAT': 'image/png', 'TRANSPARENT': 'true', 'LAYER': lyr, 'SLD_BODY': sld, 'WIDTH': width, 'HEIGHT': height }, wmsParams);
                    HTTPUtil_1.default.post({
                        url: wmsBaseUrl,
                        params: params,
                        additionalHeaders: additionalHeaders
                    })
                        .then(function (response) {
                        if (response && response.ok) {
                            response.blob().then(function (blob) {
                                var legendDataUrl = window.URL.createObjectURL(blob);
                                _this.setState({ legendDataUrl: legendDataUrl });
                            });
                        }
                    })
                        .catch(function (error) {
                        _this.setState({
                            alt: error
                        });
                    });
                });
            }, requestDelay);
        };
        _this.state = {
            alt: 'No Image set',
            legendDataUrl: ''
        };
        _this._styleParser = new geostyler_sld_parser_1.default();
        return _this;
    }
    SLDRenderer.prototype.componentDidMount = function () {
        var symbolizers = this.props.symbolizers;
        this.setLegendGraphicUrlForRule(symbolizers);
    };
    SLDRenderer.prototype.componentDidUpdate = function (prevProps) {
        var symbolizers = this.props.symbolizers;
        if (!_isEqual(symbolizers, prevProps.symbolizers)) {
            this.setLegendGraphicUrlForRule(symbolizers);
        }
    };
    SLDRenderer.prototype.render = function () {
        var _a = this.props, onClick = _a.onClick, symbolizers = _a.symbolizers, height = _a.height, width = _a.width;
        var _b = this.state, alt = _b.alt, legendDataUrl = _b.legendDataUrl;
        return (React.createElement("div", { onClick: function (event) {
                if (onClick) {
                    onClick(symbolizers, event);
                }
            }, className: "gs-symbolizer-sldrenderer" },
            React.createElement("img", { width: width, height: height, src: legendDataUrl, alt: alt })));
    };
    SLDRenderer.defaultProps = {
        requestDelay: 500,
        width: 150,
        height: 100
    };
    return SLDRenderer;
}(React.Component));
exports.SLDRenderer = SLDRenderer;
exports.default = SLDRenderer;
//# sourceMappingURL=SLDRenderer.js.map